import { render, staticRenderFns } from "./infoCheck.vue?vue&type=template&id=5b870c34&scoped=true&"
import script from "./infoCheck.vue?vue&type=script&lang=js&"
export * from "./infoCheck.vue?vue&type=script&lang=js&"
import style0 from "./infoCheck.vue?vue&type=style&index=0&id=5b870c34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b870c34",
  null
  
)

export default component.exports